import React from 'react';
import { StepProps } from '../MultiStepModal';

export default function JobDetailsStep({ data, onDataChange }: StepProps) {
  const handleInputChange = (field: string, value: string) => {
    onDataChange({ [field]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission is handled by parent component
  };

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Job Details</h3>
        <p className="step-form-subtitle">Provide basic information about the job</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form-content">
        <div className="form-group">
          <label className="form-label">Job Title *</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g., Boiler Service, Gas Safety Check"
            value={data.title || ''}
            onChange={(e) => handleInputChange('title', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Job Type *</label>
          <select
            className="form-select"
            value={data.type || ''}
            onChange={(e) => handleInputChange('type', e.target.value)}
            required
          >
            <option value="">Select job type</option>
            <option value="boiler-service">Boiler Service</option>
            <option value="gas-safety">Gas Safety Check</option>
            <option value="central-heating">Central Heating Repair</option>
            <option value="electrical">Electrical Installation</option>
            <option value="plumbing">Plumbing Repair</option>
            <option value="maintenance">General Maintenance</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Description</label>
          <textarea
            className="form-textarea"
            placeholder="Describe the work to be performed..."
            value={data.description || ''}
            onChange={(e) => handleInputChange('description', e.target.value)}
            rows={3}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Priority *</label>
          <div className="radio-group">
            {[
              { value: 'LOW', label: 'Low', color: '#6B7280' },
              { value: 'MEDIUM', label: 'Medium', color: '#3B82F6' },
              { value: 'HIGH', label: 'High', color: '#EF4444' }
            ].map((priority) => (
              <label key={priority.value} className="radio-option">
                <input
                  type="radio"
                  name="priority"
                  value={priority.value}
                  checked={data.priority === priority.value}
                  onChange={(e) => handleInputChange('priority', e.target.value)}
                />
                <span className="radio-label" style={{ color: priority.color }}>
                  {priority.label}
                </span>
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Estimated Duration</label>
          <select
            className="form-select"
            value={data.duration || ''}
            onChange={(e) => handleInputChange('duration', e.target.value)}
          >
            <option value="">Select duration</option>
            <option value="1">1 hour</option>
            <option value="2">2 hours</option>
            <option value="4">Half day (4 hours)</option>
            <option value="8">Full day (8 hours)</option>
            <option value="16">2 days</option>
            <option value="custom">Custom</option>
          </select>
        </div>
      </form>
    </div>
  );
}
